export enum ELanguages {
  EN = 'en',
  SP = 'sp',
}
